import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { memo } from "react"

import { getUserDisplayLabel } from "../../utils/users"
import { UserIcon } from "../Icons/UserIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface UserMultiSelectGroupProps extends MenuMultiSelectGroupProps<User> {
	users: User[]
}

export const UserMultiSelectGroup = memo<UserMultiSelectGroupProps>((props) => {
	const { ref, users, ...rest } = props

	return (
		<Menu.MultiSelectGroup<User> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{users.map((user) => {
				return (
					<MultiSelectItemTemplate<User> key={user.id} value={user}>
						<UserIcon userId={user.id} size="xs" />
						<Text className="truncate">{getUserDisplayLabel(user)}</Text>
					</MultiSelectItemTemplate>
				)
			})}
		</Menu.MultiSelectGroup>
	)
})
UserMultiSelectGroup.displayName = "UserMultiSelectGroup"
